<ng-template #optionTemplate let-item="item">
    <div class="places-suggestion__option">
        <shared-icon icon="pin" class="places-suggestion__icon"></shared-icon>

        <div class="places-suggestion__title"
            [innerHtml]="item?.structured_formatting?.main_text | highlightMatch: searchTerm">
        </div>
        <div class="places-suggestion__description">
            {{item?.structured_formatting?.secondary_text}}
        </div>

    </div>
</ng-template>

<shared-drop-down [refElem]="refElem" class="places-suggestion" theme="light-2" mode="menu" width="full" size="lg"
    projection="global" [open]="open" (onSelected)="handleOnSelected($event)" (onToggle)="handleOnToggle($event)"
    [options]="options$ | async" [optionTemplate]="optionTemplate" [openEvent]="null" [postContent]="googleLogo">
    <ng-content></ng-content>
</shared-drop-down>

<ng-template #googleLogo>
    <div class="places-suggestion__google-logo">
        <img directive-image-preload url="/assets/images/powered_by_google_on_white_hdpi.png" alt="Powered by Google"
            width="109" height="14" />
    </div>
</ng-template>
